import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import className from 'classnames';
import { Spinner, Button, Modal } from 'react-bootstrap';

import { getAll } from '../../../_actions/questionnaire.actions'
import { alertActions } from '../../../_actions/alert.actions';
import { questionnaireService as service } from '../../../_services/questionnaires.service'
import QuestionnairesEmpty from './Empty';

class List extends Component {

  constructor(props) {
    super(props);

    this.state = {
      copying: false,
      showCopyModal: false,
      copyId: null,
      title: ''
    }
    this.handleCopy = this.handleCopy.bind(this);
    this.handleEnterKey = this.handleEnterKey.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(getAll());
  }

  handleEnterKey(e) {
    e.preventDefault();
    if (this.state.title !== '' && !this.state.copying) {
      this.handleCopy();
    }
  }

  handleCopy() {
    if (this.state.title.trim()) {
      this.setState({ copying: true });

      service.copy(this.state.copyId, this.state.title)
        .then(() => {
          this.resetCopyModal();
          this.props.dispatch(getAll());
          this.props.dispatch(alertActions.success('Questionnaire Copied!'));
        })
        .catch(() => {
          this.resetCopyModal();
          this.props.dispatch(alertActions.error('Could not copy at this time. Please try again.'));
        });
    } else {
      alert("Please enter a title");
    }
  }

  resetCopyModal = () => {
    this.setState({
      copying: false,
      showCopyModal: false,
      copyId: null,
      title: ''
    });
  }

  render() {
    const { collection, isLoading } = this.props;

    return (
      <div className="row">
        <div className="col-lg-8">
          <h3>Form Library</h3>
        </div>

        <div className="col-lg-4 text-right">
          <Link className="btn btn-primary rounded" to="/questionnaires/create">
            <i className="fa fa-plus"></i>&nbsp; Create Form
          </Link>
        </div>

        <div className="col mt-4">
          <div className="card axs-shadow">
            <div className="card-body">

              {isLoading &&
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              }

              {!isLoading && collection.data.length === 0 &&
                <QuestionnairesEmpty />
              }

              {!isLoading && collection.data.length > 0 &&
                <>
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Status</th>
                        <th scope="col">Name</th>
                        <th scope="col">Type</th>
                        <th style={{ width: '15%' }}>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {collection.data.map((questionnaire) => {
                        const badge = className('badge', 'text-uppercase', {
                          'badge-light': questionnaire.status === 'draft',
                          'badge-primary': questionnaire.status === 'active',
                          'badge-secondary': questionnaire.status === 'retired',
                          'badge-warning': questionnaire.status === 'unknown'
                        });

                        return <tr key={questionnaire.id}>
                          <th scope="row">{questionnaire.id}</th>
                          <td>
                            <span className={badge}>{questionnaire.status}</span>
                          </td>
                          <td>{questionnaire.title}</td>
                          <td>
                            {questionnaire.type.data.map((type, i) => {
                              return <><span key={i} className="badge badge-info text-uppercase">{type.name}</span>&nbsp;</>
                            })}
                          </td>
                          <td>
                            <Button onClick={() => this.setState({ showCopyModal: true, copyId: questionnaire.id })} variant="outline-primary">Copy</Button>
                            <Link className="btn btn-outline-primary ml-1" to={`/questionnaires/${questionnaire.id}/edit`}>Edit</Link>
                          </td>
                        </tr>
                      })}
                    </tbody>
                  </table>

                  <Modal show={this.state.showCopyModal} onHide={() => this.resetCopyModal()}>
                    <Modal.Header closeButton>
                      <Modal.Title>Copy Questionnaire</Modal.Title>
                    </Modal.Header>

                    <Modal.Body onSubmit={this.handleEnterKey}>
                      <form className="mt-4">
                        <div className="form-group">
                          <label><span className="text-danger">*</span> Title</label> &nbsp;
                          <input onChange={(e) => this.setState({ title: e.target.value })} type="text" className="form-control" />
                        </div>
                      </form>
                    </Modal.Body>

                    <Modal.Footer>
                      <Button onClick={() => this.handleCopy()}
                        disabled={this.state.title === '' || this.state.copying}
                        variant="primary"
                      >
                        {this.state.copying ? 'Copying...' : 'Copy'}
                      </Button>
                      <Button variant="secondary" onClick={() => this.resetCopyModal()}>
                        Cancel
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.questionnaire.isLoading,
    collection: state.questionnaire.collection
  }
}

export default connect(mapStateToProps)(List);